import buildEnum from 'utils/buildEnum';

export const contactFields = {
  callbackEta: 'callbackEta',
  callbackRollTime: 'callbackRollTime',
  contactType: 'contactType',
  email: 'email',
  name: 'name',
  phone: 'phone',
  phoneExt: 'phoneExt',
};

export const fieldIds = buildEnum(
  ['name', 'phone', 'email'],
  key => `contact.{index}.${key}`,
);



// WEBPACK FOOTER //
// ./src/compositions/CaseContacts/ContactDetails/constants.js